// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:940px){.suggestion[data-v-47e25f10]{margin:20px}.suggestion h2[data-v-47e25f10]{font-size:24px;font-weight:700;line-height:30px}.suggestion-products[data-v-47e25f10]{gap:24px;grid-template-columns:1fr 1fr}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
